import { selectors } from "store";

const rateSelectors = selectors.rate;

export default rateSelectors;
